import React, { useState, useEffect } from 'react';
import { message, Radio, Popconfirm, Select, Alert, Statistic, Card, Empty, Spin, Avatar, Tag, Tabs, Popover, Form, Modal, Table, Row, Col, Button, Icon, Skeleton } from 'antd';
import { useMappedState } from 'redux-react-hook';
import ReportPanel from './../components/reportPanel';
import TransactionPanel from './../components/transactionPanel';
import CustomAvatar from './../components/customAvatar';
import RenderTooltipCurrency from './../components/renderTooltipCurrency';
import RenderToolTipWaiting from './../components/renderToolTipWaiting';
import RenderTooltipDetail from './../components/renderTooltipDetail';
import RenderTooltipEdit from './../components/renderTooltipEdit';
import RenderTooltipDelete from './../components/renderTooltipDelete';
import CreateInvoiceForm from './../forms/createInvoiceForm';
import EditInvoiceForm from './../forms/editInvoiceForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { getMyaccount, getReport, createInvoice, getClient, getClients, getCandidates, getOffers } from './../API';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { flexCenterRight } from './../theme';
import { editInvoice, getInvoices, getTransactions } from './../API';
import moment from 'moment';
import { s3, COLORS, getAvatar, buildYearArr, getFinancialYear } from './../utils';
import { navigate } from "@reach/router";
import { format } from 'timeago.js';
import {
  PieChart, Pie, Sector, Cell, ComposedChart, Area, Bar,
  ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend
} from 'recharts';

import { getCurrencySign } from './../utils/invoices';
import { renderTooltip } from './../utils/helper';
import { useDispatch } from 'redux-react-hook';

const { sumBy, orderBy } = require('lodash');

const { TabPane } = Tabs;
const { Option } = Select;

function TheInvoices({ form }) {
  const dispatch = useDispatch();

  const yearsArr = buildYearArr('2022');

  const session = useMappedState(state => state.session);

  const [reportLoading, setReportLoading] = useState(false);
  const [reportData, setReportData] = useState(null);

  const [activeTab, setActiveTab] = useState('1');
  const [activeYear, setActiveYear] = useState(0);

  const [showRateModal, setShowRateModal] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [editing, setEditing] = useState(false);

  const [clients, setClients] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [offers, setOffers] = useState([]);

  const [transactions, setTransactions] = useState([]);
  const [invoices, setInvoices] = useState(null);
  const [users, setUsers] = useState([]);

  const [showCreateInvoiceModal, setShowCreateInvoiceModal] = useState(false);
  const [showEditInvoiceModal, setShowEditInvoiceModal] = useState(false);

  const [entry, setEntry] = useState(null);

  const [creating, setCreating] = useState(false);
  const [removing, setRemoving] = useState(false);

  const [sgdRate, setSgdRate] = useState(null);
  const [hkdRate, setHkdRate] = useState(null);
  const [currencyUpdate, setCurrencyUpdate] = useState(null);

  const [paymentReceivedPanel, setPaymentReceivedPanel] = useState('current year');
  const [withdrawPanel, setWithdrawPanel] = useState('current year');

  const buildInvoices = (data) => {
    const onGoingInvoices = orderBy(data.invoices.filter((i) => i.isActive && !i.paymentReceived), ['onBoard'], ['desc']);
    const paidInvoices = orderBy(data.invoices.filter((i) => i.paymentReceived), ['paymentReceivedDate'], ['desc']);
    const withdrawInvoices = orderBy(data.invoices.filter((i) => !i.isActive), ['withdrawDate'], ['desc']);

    return {
      totalGBP: data.totalGBP.length > 0 ? data.totalGBP[0].total : 0,
      totalSGD: data.totalSGD.length > 0 ? data.totalSGD[0].total : 0,
      totalHKD: data.totalHKD.length > 0 ? data.totalHKD[0].total : 0,
      totalSGDtoGBP: data.totalSGDtoGBP.length > 0 ? data.totalSGDtoGBP[0].total : 0,
      totalHKDtoGBP: data.totalHKDtoGBP.length > 0 ? data.totalHKDtoGBP[0].total : 0,
      totalInvoices: data.totalInvoices,
      invoicesNumberStatistic: data.invoicesNumberStatistic,
      invoicesMoneyStatistic: data.invoicesMoneyStatistic,
      onGoingInvoices,
      paidInvoices,
      withdrawInvoices,
    }
  }

  const data1 = [
    {
      name: 'On Going',
      value: invoices && invoices.onGoingInvoices ? invoices.onGoingInvoices.length : 0,
    },
    {
      name: 'Full Payment Received',
      value: invoices && invoices.paidInvoices ? invoices.paidInvoices.filter((i) => i.actualRefund === 0).length : 0,
    },
    {
      name: 'Partial Payment Received',
      value: invoices && invoices.paidInvoices ? invoices.paidInvoices.filter((i) => i.actualRefund !== 0 && (i.actualFee - i.actualRefund) > 0).length : 0,
    },
    {
      name: 'Full Refund',
      value: invoices && invoices.paidInvoices ? invoices.paidInvoices.filter((i) => i.actualRefund !== 0 && (i.actualFee - i.actualRefund) === 0).length : 0,
    },
    {
      name: 'Withdraw',
      value: invoices && invoices.withdrawInvoices ? invoices.withdrawInvoices.length : 0,
    },
  ];

  let data2;
  if (invoices) {
    data2 = Object.keys(invoices.invoicesNumberStatistic).map(k => {
      return {
        month: moment(k).format('MMM'),
        invoices: invoices.invoicesNumberStatistic[k].active,
        withdraw: invoices.invoicesNumberStatistic[k].inActive,
      }
    })
  }

  let data3;
  if (invoices) {
    data3 = Object.keys(invoices.invoicesMoneyStatistic).map(k => {
      return {
        month: moment(k).format('MMM'),
        gbp: invoices.invoicesMoneyStatistic[k].gbp,
        sgd: invoices.invoicesMoneyStatistic[k].sgd,
        hkd: invoices.invoicesMoneyStatistic[k].hkd,
      }
    })
  }

  useEffect(() => {
    async function fetchData() {
      const dataResponse = await Promise.all([
        getClients(session.authToken),
        getCandidates(session.authToken),
        getOffers(session.authToken),
        getInvoices(session.authToken),
        getReport(session.authToken, yearsArr[0].start, yearsArr[0].end, yearsArr[0].type),
        getMyaccount(session.authToken),
        getTransactions(session.authToken),
      ]);

      setSgdRate(1 / dataResponse[3].data.currency.data.rates.SGD);
      setHkdRate(1 / dataResponse[3].data.currency.data.rates.HKD);
      setCurrencyUpdate(dataResponse[3].data.currency.updatedAt);

      setClients(dataResponse[0].data.clients);
      setCandidates(dataResponse[1].data.candidates);
      setOffers(dataResponse[2].data.data.filter((i) => !i.invoice_docs));
      setUsers(dataResponse[3].data.users.filter(i => i.email !== 'finance@linkglobalrecruitment.com'));
      setInvoices(buildInvoices(dataResponse[3].data));
      setReportData({
        period: dataResponse[4].data.period,
        data: dataResponse[4].data.data,
        chartData: dataResponse[4].data.chartData,
      });
      setTransactions(dataResponse[6].data.transactions);
      dispatch({ type: "INIT_ME", payload: dataResponse[5].data.me });

      setLoading(false);
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  const CustomizedAxisTick = props => {
    const { x, y, payload } = props
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666">{payload.value}</text>
      </g>
    )
  }

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
      fill, payload, percent, value,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${value}`}</text>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
          {`${(percent * 100).toFixed(2)}%`}
        </text>
      </g>
    );
  };

  const renderGBP = (invoice) => {
    switch (invoice.currency) {
      case 'SGD':
        return <Tag>£{(invoice.fee * sgdRate).toFixed(2)}</Tag>;
      case 'HKD':
        return <Tag>£{(invoice.fee * hkdRate).toFixed(2)}</Tag>;
      default:
        return <Tag>N/A</Tag>
    }
  }

  const popoverContent = (invoice) => {
    return (
      <>
        <div style={{ margin: '5px 0px 5px 0px' }}>
          <span style={{ fontWeight: 600 }}>Fee</span>: <Tag color="#f50">{getCurrencySign(invoice.currency)}{invoice.fee.toLocaleString()}</Tag>/&nbsp;&nbsp;{renderGBP(invoice)}
        </div>
        <div style={{ margin: '5px 0px 5px 0px' }}>
          <span style={{ fontWeight: 600 }}>Currency</span>: {invoice.currency}
        </div>
        <div style={{ margin: '5px 0px 5px 0px' }}>
          <span style={{ fontWeight: 600 }}>Location</span>: {invoice.location}
        </div>
        <div style={{ marginBottom: '10px' }} />
        <div style={{ margin: '5px 0px 5px 0px' }}>
          <span style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(`/contacts/${invoice.contact_docs.id}`);
            }}
          >
            <CustomAvatar
              colourCode={invoice.contact_docs.firstname.charAt(0).toLowerCase()}
              char={`${invoice.contact_docs.firstname.charAt(0).toUpperCase()}${invoice.contact_docs.lastname.charAt(0).toUpperCase()}`}
              charSize={12}
              src={getAvatar('contact', invoice.contact_docs.id)}
            />
            &nbsp;
            {`${invoice.contact_docs.firstname} ${invoice.contact_docs.lastname}`}
          </span>
        </div>
        {
          invoice.additionalContact_docs ? (
            <div style={{ margin: '5px 0px 5px 0px' }}>
              <span style={{ cursor: 'pointer' }}
                onClick={() => {
                  navigate(`/contacts/${invoice.additionalContact_docs.id}`);
                }}
              >
                <CustomAvatar
                  colourCode={invoice.additionalContact_docs.firstname.charAt(0).toLowerCase()}
                  char={`${invoice.additionalContact_docs.firstname.charAt(0).toUpperCase()}${invoice.additionalContact_docs.lastname.charAt(0).toUpperCase()}`}
                  charSize={12}
                  src={getAvatar('contact', invoice.additionalContact_docs.id)}
                />
                &nbsp;
                {`${invoice.additionalContact_docs.firstname} ${invoice.additionalContact_docs.lastname}`}
              </span>
            </div>
          ) : null
        }
        {
          invoice.offer_docs ? (
            <div style={{ marginTop: '10px' }}>
              <Card size="small" bordered={true} title="Offer">
                <div style={{ margin: '5px 0px 5px 0px' }}>
                  <span style={{ fontWeight: 600 }}>Salary</span>: {getCurrencySign(invoice.offer_docs.currency)}{invoice.offer_docs.salary.toLocaleString()} / monthly
                </div>
                {
                  invoice.offer_docs.signOnBonus && invoice.offer_docs.signOnBonus !== '' ? (
                    <div style={{ margin: '5px 0px 5px 0px' }}>
                      <span style={{ fontWeight: 600 }}>Sign On Bonus</span>: {invoice.offer_docs.signOnBonus.toLocaleString()}
                    </div>
                  ) : null
                }
                {
                  invoice.offer_docs.bonus && invoice.offer_docs.bonus !== '' ? (
                    <div style={{ margin: '5px 0px 5px 0px' }}>
                      <span style={{ fontWeight: 600 }}>Bonus</span>: {invoice.offer_docs.bonus}
                    </div>
                  ) : null
                }
                {
                  invoice.offer_docs.relocationAllowance && invoice.offer_docs.relocationAllowance !== '' ? (
                    <div style={{ margin: '5px 0px 5px 0px' }}>
                      <span style={{ fontWeight: 600 }}>Relocation Allowance</span>: {invoice.offer_docs.relocationAllowance}
                    </div>
                  ) : null
                }
              </Card>
            </div>
          ) : null
        }
      </>
    )
  }

  const renderInvoiceStatus = (invoice) => {
    const paymentDay = moment(invoice.onBoard).add(invoice.paymentTerm, 'days');
    const currentDay = moment();
    const diffDay = currentDay.diff(paymentDay, 'days');
    if (invoice.sendInvoice) {
      return (
        <>
          {
            diffDay > 0 ? (
              <RenderToolTipWaiting title={`Payment already due ${Math.abs(diffDay)} days`} />
            ) : (
              <RenderToolTipWaiting title={`${Math.abs(diffDay)} days left to check payment`} />
            )
          }
        </>

      )
    }
    if (moment() < moment(invoice.onBoard)) {
      return (
        <Tag color="#7CB9E8">Waiting Candidate On Board</Tag>
      )
    }
    if (moment() > moment(invoice.onBoard) &&
      moment() < moment(invoice.onBoard).add(1, 'days')) {
      return (
        <Tag color="#FF8C00">Waiting Send Invoice</Tag>
      )
    }
    if (!invoice.sendInvoice &&
      moment() > moment(invoice.onBoard).add(1, 'days')) {
      return (
        <Tag color="#FF8C00">Waiting Send Invoice</Tag>
      )
    }
  }

  const columns = [
    {
      title: 'Candidate',
      width: '17%',
      key: 'candidate',
      sorter: (a, b) => a.candidate_docs.firstname.localeCompare(b.candidate_docs.firstname),
      render: invoice =>
        <div>
          <span style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(`/candidates/${invoice.candidate_docs.id}`);
            }}
          >
            <CustomAvatar
              colourCode={invoice.candidate_docs.firstname.charAt(0).toLowerCase()}
              char={`${invoice.candidate_docs.firstname.charAt(0).toUpperCase()}${invoice.candidate_docs.lastname.charAt(0).toUpperCase()}`}
              charSize={12}
              src={getAvatar('candidate', invoice.candidate_docs.id)}
            />
            &nbsp;
            {`${invoice.candidate_docs.firstname} ${invoice.candidate_docs.lastname}`}
          </span>
        </div>
    },
    {
      title: 'Client',
      width: '17%',
      key: 'name',
      sorter: (a, b) => a.client_docs.name.localeCompare(b.client_docs.name),
      render: invoice =>
        <div style={{ cursor: 'pointer' }}
          onClick={() => {
            navigate(`/clients/${invoice.client_docs.id}`);
          }}>
          <CustomAvatar
            colourCode={invoice.client_docs.name.charAt(0).toLowerCase()}
            char={`${invoice.client_docs.name.charAt(0).toUpperCase()}`}
            charSize={12}
            src={getAvatar('client', invoice.client_docs.id)}
          />
          &nbsp;
          {invoice.client_docs.name}
        </div>
    },
    {
      title: '',
      width: '1%',
      key: 'icon',
      render: invoice =>
        <Popover
          overlayStyle={{
            width: '23vw',
          }}
          placement="right"
          content={popoverContent(invoice)}
        >
          <Icon type="info-circle" theme="filled" style={{ color: '#72A0C1', fontSize: '18px' }} />
        </Popover>
    },
    {
      title: 'On Board (UK)',
      width: '15%',
      key: 'date',
      sorter: (a, b) => a.onBoard.localeCompare(b.onBoard),
      render: invoice =>
        <div>
          {moment(invoice.onBoard).format("YYYY-MM-DD HH:mm")}
        </div>
    },
  ];

  const columnButtons = [
    {
      title: '',
      width: '10%',
      key: 'button',
      render: invoice =>
        <div style={flexCenterRight}>
          <RenderTooltipDetail handleOnClick={() => {
            navigate(`/invoices/${invoice.id}`);
          }} />
          &nbsp;&nbsp;
          <RenderTooltipEdit disabled={invoice.sendInvoice || invoice.user_docs.id !== session.id} handleOnClick={async () => {
            setEntry(invoice);
            setShowEditInvoiceModal(true);

            // // load client's contact here
            const response = await getClient(session.authToken, invoice.client_docs.id);
            setContacts(response.data.client.contacts);
          }} />
          &nbsp;&nbsp;
          <RenderTooltipDelete disabled={invoice.user_docs.id !== session.id} handleOnClick={async () => {
            setUpdating(true);
            const result = await editInvoice(
              session.authToken,
              {
                type: 'withdraw',
                id: invoice.id,
              }
            );
            if (result.data.responseCode === 0) {
              const response = await getInvoices(session.authToken);
              setInvoices(buildInvoices(response.data));
              setUpdating(false);
              message.success(result.data.message);
            }
            else {
              setUpdating(false);
              message.error(result.data.message.toString());
            }
          }} />
          &nbsp;&nbsp;
          <CustomAvatar
            showTooltip={true}
            tooltipTitle={invoice.user_docs.id === session.id ? 'Me' : `${invoice.user_docs.firstname} ${invoice.user_docs.lastname}`}
            colourCode={invoice.user_docs.firstname.charAt(0).toLowerCase()}
            char={`${invoice.user_docs.firstname.charAt(0).toUpperCase()}${invoice.user_docs.lastname.charAt(0).toUpperCase()}`}
            charSize={12}
            size={24}
            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${invoice.user_docs.id}.jpeg`}
          />
        </div>
    },
  ];

  const columnButton = [
    {
      title: '',
      width: '5%',
      key: 'button',
      render: invoice =>
        <div style={flexCenterRight}>
          <RenderTooltipDetail handleOnClick={() => {
            navigate(`/invoices/${invoice.id}`);
          }} />
          &nbsp;&nbsp;
          <CustomAvatar
            showTooltip={true}
            tooltipTitle={invoice.user_docs.id === session.id ? 'Me' : `${invoice.user_docs.firstname} ${invoice.user_docs.lastname}`}
            colourCode={invoice.user_docs.firstname.charAt(0).toLowerCase()}
            char={`${invoice.user_docs.firstname.charAt(0).toUpperCase()}${invoice.user_docs.lastname.charAt(0).toUpperCase()}`}
            charSize={12}
            size={24}
            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${invoice.user_docs.id}.jpeg`}
          />
        </div>
    },
  ];

  const columnsWithStatus = [
    ...[
      {
        title: '',
        width: '1%',
        key: 'star-icon',
        render: invoice => <>
          {
            invoice.rebateTerm === 0 ? (
              <>{renderTooltip()}</>
            ) : null
          }
        </>
      },
      {
        title: 'Status',
        width: '15%',
        key: 'reminders',
        render: invoice =>
          <div>
            {renderInvoiceStatus(invoice)}
          </div>
      }],
    ...columns,
    ...[
      {
        title: 'Taken By',
        width: '8%',
        render: invoice =>
          <div style={{ marginLeft: '15px' }}>
            <div style={{
              display: 'inline-flex',
              flexDirection: 'row-reverse'
            }}>
              {showUserAvatar(invoice)}
            </div>
          </div>
      }
    ],
    ...columnButtons
  ]

  const showUserAvatar = (invoice) => {
    const userArr = [];
    for (const each of invoice.takenBy) {
      const found = users.find((i) => i._id === each);
      if (found) {
        userArr.push(found);
      }
    }

    return (
      userArr.reverse().map(i =>
        <div key={i.id} style={{ cursor: 'pointer' }}>
          <CustomAvatar
            showTooltip={true}
            tooltipTitle={`${i.firstname} ${i.lastname}`}
            style={{
              marginLeft: "-15px",
              position: "relative",
              border: "1px solid #fff",
              overflow: "hidden",
            }}
            colourCode={i.firstname.charAt(0).toLowerCase()}
            char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
            charSize={12}
            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${i.id}.jpeg`}
          />
        </div>
      )
    )
  }

  const renderPaymentInfo = (invoice) => {
    const currentDate = moment();
    const finishDate = moment(invoice.onBoard).add(invoice.rebateTerm, 'days');
    const diff = finishDate.diff(currentDate, 'days');
    if (invoice.actualRefund > 0) {
      return (
        <>
          {
            invoice.actualFee - invoice.actualRefund > 0 ? (
              <Popover
                placement="top"
                content={<div>This invoice refund: {getCurrencySign(invoice.actualCurrency)}{invoice.actualRefund}</div>}
              >
                <Avatar style={{ color: '#fff', backgroundColor: '#b7eb8f' }} size={20} icon={<FontAwesomeIcon icon={faCheck} />} />
              </Popover>
            ) : (
              <Popover
                placement="top"
                content={<div>This invoice full refund: {getCurrencySign(invoice.actualCurrency)}{invoice.actualRefund}</div>}
              >
                <Avatar style={{ color: '#fff', backgroundColor: '#ccc' }} size={20} icon={<FontAwesomeIcon icon={faCheck} />} />
              </Popover>
            )
          }
        </>
      )
    } else {
      return (
        <Popover
          placement="top"
          content={<div>
            {
              diff > 0 ? (
                <span>This invoice is full payment, <b>{diff}</b> days to go finish rebate</span>
              ) : (
                <span>This invoice is full payment</span>
              )
            }
          </div>
          }
        >
          <Avatar style={{ color: '#fff', backgroundColor: `${diff > 0 ? '#FB607F' : '#73d13d'}` }} size={20} icon={<FontAwesomeIcon icon={faCheck} />} />
        </Popover>
      )
    }
  }

  const renderInvoiceMeta = (invoice) => {
    if (invoice.meta && invoice.meta.part) {
      return (
        <Popover
          placement="top"
          content={<div>{invoice.meta.part}</div>}
        >
          <Avatar style={{ color: '#fff', backgroundColor: '#DE5D83' }} size={20} icon={<FontAwesomeIcon icon={faBookmark} />} />
        </Popover>
      )
    }
  }

  const columnsPaid = [
    ...columns,
    ...[{
      title: 'Received Fee',
      width: '10%',
      render: invoice =>
        <b>
          {
            invoice.convertGBP > 0 ? (
              <Tag color="#f50">
                {getCurrencySign(invoice.actualCurrency)}{(invoice.actualFee - invoice.actualRefund).toLocaleString()}
                / <span style={{ fontSize: '10px' }}>{`£${(invoice.convertGBP - (invoice.convertGBPRefund ? invoice.convertGBPRefund : 0)).toLocaleString()}`}</span>
              </Tag>
            ) : (
              <Tag color="#f50">{getCurrencySign(invoice.actualCurrency)}{(invoice.actualFee - invoice.actualRefund).toLocaleString()}</Tag>
            )
          }
        </b>
    },
    {
      title: '',
      width: '1%',
      render: invoice => renderInvoiceMeta(invoice)
    },
    {
      title: '',
      width: '1%',
      render: invoice => renderPaymentInfo(invoice)
    },
    {
      title: 'Taken',
      width: '5%',
      render: invoice =>
        <div style={{ marginLeft: '15px' }}>
          <div style={{
            display: 'inline-flex',
            flexDirection: 'row-reverse'
          }}>
            {showUserAvatar(invoice)}
          </div>
        </div>
    }
    ],
    ...columnButton
  ];

  const columnsWithdraw = [
    ...columns,
    ...[{
      title: 'Withdraw At',
      width: '15%',
      render: invoice =>
        <div style={{ color: '#aaa' }}>
          <i>{format(new Date(moment(invoice.withdrawDate).format('YYYY-MM-DD HH:mm:ss')))}</i>
        </div>
    },
    {
      title: '',
      width: '1%',
      render: invoice =>
        <div>
          <Avatar style={{ color: '#fff', backgroundColor: 'red' }} size={20} icon={<FontAwesomeIcon icon={faTrash} />} />
        </div>
    },
    ],
    ...columnButton,
  ];

  const renderCard = (color, number, text, prefix, suffix) => {
    return (
      <Card size="small" style={{ marginLeft: '5px', marginRight: '5px', backgroundColor: color }}>
        {
          prefix ? (
            <Statistic title="" valueStyle={{ fontSize: '28px', color: '#fff' }} value={number} prefix={prefix} suffix={suffix} />
          ) : (
            <Statistic title="" valueStyle={{ fontSize: '28px', color: '#fff' }} value={number} suffix={suffix} />
          )
        }
        <Row>
          <Col span={18}>
            <div style={{ color: 'white' }}>{text}</div>
          </Col>
          <Col span={6}>
            <div style={flexCenterRight}>
              <FontAwesomeIcon
                style={{
                  cursor: 'pointer',
                  marginTop: '5px',
                  fontSize: '14px',
                  color: 'white'
                }} icon={faInfoCircle} />
            </div>
          </Col>
        </Row>
      </Card>
    )
  }

  const buildAlertMessage = (invoices) => {
    if (invoices) {
      const gbp = invoices.onGoingInvoices.filter((i) => i.currency === 'GBP');
      const sgd = invoices.onGoingInvoices.filter((i) => i.currency === 'SGD');
      const hkd = invoices.onGoingInvoices.filter((i) => i.currency === 'HKD');

      const sgdTotal = sumBy(sgd, 'fee');
      const gbpTotal = sumBy(gbp, 'fee');
      const hkdTotal = sumBy(hkd, 'fee');

      return <Row>
        <Col span={20} >
          Estimated Fee
          1. Great British Pounds <RenderTooltipCurrency currency={getCurrencySign('GBP')} amount={gbpTotal} rate={0} />
          2. Singapore Dollars  <RenderTooltipCurrency currency={getCurrencySign('SGD')} amount={sgdTotal} rate={sgdRate} />
          3. Hong Kong Dollar <RenderTooltipCurrency currency={getCurrencySign('HKD')} amount={hkdTotal} rate={hkdRate} />
        </Col>
        <Col span={4} style={flexCenterRight}>
          <Tag color="#B284BE"><b>£{(gbpTotal + sgdTotal * sgdRate + hkdTotal * hkdRate).toFixed(2)}</b></Tag>
        </Col>
      </Row>
    }
  }

  const renderWithdrawPanel = () => {
    const currentYear = getFinancialYear();
    const start = new Date(`${currentYear}-01-31`);
    const end = new Date(`${currentYear + 1}-01-31`);
    if (withdrawPanel === 'current year') {
      return (
        <Table
          pagination={false}
          columns={columnsWithdraw}
          dataSource={invoices.withdrawInvoices.filter(i => moment(i.withdrawDate) > moment(start) && moment(i.withdrawDate) < moment(end))}
          rowKey="id"
        />
      )
    }
    if (withdrawPanel === 'all time') {
      return (
        <Table
          columns={columnsWithdraw}
          dataSource={invoices.withdrawInvoices}
          rowKey="id"
        />
      )
    }
  }

  const renderPaymentReceivedPanel = () => {
    const currentYear = getFinancialYear();
    const start = new Date(`${currentYear}-01-31`);
    const end = new Date(`${currentYear + 1}-01-31`);
    if (paymentReceivedPanel === 'current year') {
      return (
        <Table
          pagination={false}
          columns={columnsPaid}
          dataSource={invoices.paidInvoices.filter(i => moment(i.paymentReceivedDate) > moment(start) && moment(i.paymentReceivedDate) < moment(end))}
          rowKey="id"
        />
      )
    }
    if (paymentReceivedPanel === 'all time') {
      return (
        <Table
          columns={columnsPaid}
          dataSource={invoices.paidInvoices}
          rowKey="id"
        />
      )
    }
  }

  const calculateEstimate = (invoice) => {
    if (invoice.actualCurrency === 'SGD') {
      return (invoice.actualFee - invoice.actualRefund) * sgdRate;
    }
    if (invoice.actualCurrency === 'HKD') {
      return (invoice.actualFee - invoice.actualRefund) * hkdRate;
    }
  }

  const renderCurrentYearTotal = () => {
    const currentYear = getFinancialYear();
    const start = new Date(`${currentYear}-01-31`);
    const end = new Date(`${currentYear + 1}-01-31`);
    let yearTotal = invoices.paidInvoices.filter(i => i.convertGBPDate && moment(i.paymentReceivedDate) > moment(start) && moment(i.paymentReceivedDate) < moment(end));
    yearTotal = yearTotal.map((i) => {
      return i.convertGBP - i.convertGBPRefund
    });

    const total = parseFloat(sumBy(yearTotal).toFixed(2));

    let yearTotalNotConvert = invoices.paidInvoices.filter(i => !i.convertGBPDate && moment(i.paymentReceivedDate) > moment(start) && moment(i.paymentReceivedDate) < moment(end));
    yearTotalNotConvert = yearTotalNotConvert.map((i) => {
      return calculateEstimate(i)
    });

    const totalNotConvert = parseFloat(sumBy(yearTotalNotConvert).toFixed(2));

    return (
      <div>
        <span>Total GBP: <Tag color="#8DB600">£{total.toLocaleString()}</Tag></span>
        &nbsp;&nbsp;
        <span>Estimate Converted GBP: <Tag color="#f50">£{totalNotConvert.toLocaleString()}</Tag></span>
      </div>
    )
  }

  return (
    loading ?
      <div>
        <p>Loading...</p>
        <Skeleton active />
      </div>
      :
      <Form>
        {
          showRateModal ? (
            <Modal
              zIndex={100}
              centered={true}
              closable={false}
              visible={showRateModal}
              width="60%"
              footer={[
                <Button
                  key="close" onClick={() => {
                    setShowRateModal(false);
                  }}>
                  <Icon type="close" />
                  Close
                </Button>,
              ]}
            >
              <div>
                <Tabs type="card" size="small">
                  <TabPane tab="Singapore Dollar (S$)" key="sgd">
                    <Tabs type="card" size="small">
                      <TabPane tab="Last 30 Days" key="1">
                        <center>
                          <img alt="last-30-days" src="https://www.currency.me.uk/remote/graphs/SGD-GBP-30-day-exchange-rate-history-graph-large.png" />
                        </center>
                      </TabPane>
                      <TabPane tab="Last 6 Months" key="2">
                        <center>
                          <img alt="last-6-months" src="https://www.currency.me.uk/remote/graphs/SGD-GBP-180-day-exchange-rate-history-graph-large.png" />
                        </center>
                      </TabPane>
                      <TabPane tab="Last 1 Year" key="3">
                        <center>
                          <img alt="last-1-year" src="https://www.currency.me.uk/remote/graphs/SGD-GBP-365-day-exchange-rate-history-graph-large.png" />
                        </center>
                      </TabPane>
                      <TabPane tab="Last 5 Years" key="4">
                        <center>
                          <img alt="last-5-years" src="https://www.currency.me.uk/remote/graphs/SGD-GBP-1825-day-exchange-rate-history-graph-large.png" />
                        </center>
                      </TabPane>
                    </Tabs>
                  </TabPane>
                  <TabPane tab="Hong Kong Dollar (HK$)" key="hkd">
                    <Tabs type="card" size="small">
                      <TabPane tab="Last 30 Days" key="1">
                        <center>
                          <img alt="last-30-days" src="https://www.currency.me.uk/remote/graphs/HKD-GBP-30-day-exchange-rate-history-graph-large.png" />
                        </center>
                      </TabPane>
                      <TabPane tab="Last 6 Months" key="2">
                        <center>
                          <img alt="last-6-months" src="https://www.currency.me.uk/remote/graphs/HKD-GBP-180-day-exchange-rate-history-graph-large.png" />
                        </center>
                      </TabPane>
                      <TabPane tab="Last 1 Year" key="3">
                        <center>
                          <img alt="last-1-year" src="https://www.currency.me.uk/remote/graphs/HKD-GBP-365-day-exchange-rate-history-graph-large.png" />
                        </center>
                      </TabPane>
                      <TabPane tab="Last 5 Years" key="4">
                        <center>
                          <img alt="last-5-years" src="https://www.currency.me.uk/remote/graphs/HKD-GBP-1825-day-exchange-rate-history-graph-large.png" />
                        </center>
                      </TabPane>
                    </Tabs>
                  </TabPane>
                </Tabs>
              </div>
            </Modal>
          ) : null
        }

        {
          showCreateInvoiceModal ? (
            <Modal
              zIndex={100}
              centered={true}
              title="Create New Invoice"
              closable={false}
              visible={showCreateInvoiceModal}
              width="98%"
              footer={[
                <Button
                  disabled={creating}
                  key="cancel" onClick={() => {
                    setShowCreateInvoiceModal(false);
                  }}>
                  <Icon type="close" />
                  Close
                </Button>,
                <Button
                  disabled={creating}
                  key="create" type="primary" onClick={async () => {
                    const formResult = await form.validateFields();
                    setCreating(true);
                    let param = {
                      client: formResult.client,
                      contact: formResult.contact,
                      candidate: formResult.candidate,
                      location: formResult.location,
                      onBoard: `${moment(formResult.onBoard).format('YYYY-MM-DD')} 09:00:00`,
                      fee: formResult.fee,
                      currency: formResult.currency,
                      rebateTerm: formResult.rebateTerm,
                      paymentTerm: formResult.paymentTerm,
                      takenBy: formResult.takenBy,
                      offer: formResult.offer,
                    };

                    if (formResult.additionalContact) {
                      param = {
                        ...param,
                        ...{ additionalContact: formResult.additionalContact },
                      }
                    }

                    if (formResult.cc) {
                      param = {
                        ...param,
                        ...{ cc: formResult.cc },
                      }
                    }

                    const result = await createInvoice(session.authToken, param);

                    if (result.data.responseCode === 0) {
                      const response = await getInvoices(session.authToken);
                      setInvoices(buildInvoices(response.data));

                      const responseOffers = await getOffers(session.authToken);
                      setOffers(responseOffers.data.data.filter((i) => !i.invoice_docs));

                      setShowCreateInvoiceModal(false);
                      setCreating(false);
                      message.success(result.data.message);
                    }
                    else {
                      setCreating(false);
                      message.error(result.data.message.toString());
                    }

                  }}>
                  {
                    creating ? <Icon type="loading" /> : <Icon type="check" />
                  }
                  Submit
                </Button>
              ]}
            >
              <CreateInvoiceForm
                users={users}
                clients={clients}
                candidates={candidates}
                offers={offers.filter((i) => !i.flag)}
                form={form}
                submitting={creating}
              />
            </Modal>
          ) : null
        }

        {
          showEditInvoiceModal ? (
            <Modal
              zIndex={100}
              centered={true}
              title=<Row>
                <Col span={12}>
                  Edit Invoice
                </Col>
                <Col span={12} style={flexCenterRight}>
                  <Popconfirm
                    placement="leftTop"
                    title="Are you sure to permanent delete this invoice?"
                    onConfirm={async () => {
                      setRemoving(true);
                      const result = await editInvoice(
                        session.authToken,
                        {
                          type: 'delete',
                          id: entry.id,
                        }
                      );
                      if (result.data.responseCode === 0) {
                        const response = await getInvoices(session.authToken);
                        setInvoices(buildInvoices(response.data));
                        setShowEditInvoiceModal(false);
                        setEntry(null);
                        setRemoving(false);
                        message.success(result.data.message);
                      }
                      else {
                        setRemoving(false);
                        message.error(result.data.message.toString());
                      }
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="danger"
                      disabled={editing}
                      key="remove" onClick={() => {
                      }}>
                      {
                        removing ? <Icon type="loading" /> : <Icon type="delete" />
                      }
                      Permanent Delete
                    </Button>
                  </Popconfirm>
                </Col>
              </Row>
              closable={false}
              visible={showEditInvoiceModal}
              width="90%"
              footer={[
                <Button
                  disabled={editing}
                  key="cancel" onClick={() => {
                    setShowEditInvoiceModal(false);
                    setEntry(null);
                    setContacts([]);
                  }}>
                  <Icon type="close" />
                  Cancel
                </Button>,
                <Button
                  disabled={editing}
                  key="edit" type="primary" onClick={async () => {
                    const formResult = await form.validateFields();
                    setEditing(true);

                    let param = {
                      id: entry.id,
                      type: 'edit',
                      contact: formResult.contact,
                      location: formResult.location,
                      onBoard: `${moment(formResult.onBoard).format('YYYY-MM-DD')} 09:00:00`,
                      fee: formResult.fee,
                      currency: formResult.currency,
                      takenBy: formResult.takenBy,
                    };

                    if (formResult.additionalContact) {
                      param = {
                        ...param,
                        ...{ additionalContact: formResult.additionalContact },
                      }
                    }

                    if (formResult.cc) {
                      param = {
                        ...param,
                        ...{ cc: formResult.cc },
                      }
                    }

                    const result = await editInvoice(session.authToken, param);

                    if (result.data.responseCode === 0) {
                      const response = await getInvoices(session.authToken);
                      setInvoices(buildInvoices(response.data));
                      setShowEditInvoiceModal(false);
                      setEditing(false);
                      message.success(result.data.message);
                    }
                    else {
                      setCreating(false);
                      message.error(result.data.message.toString());
                    }
                  }}>
                  {
                    editing ? <Icon type="loading" /> : <Icon type="check" />
                  }
                  Submit
                </Button>
              ]}
            >
              {
                contacts.length > 0 ? (
                  <EditInvoiceForm
                    invoice={entry}
                    users={users}
                    clients={clients}
                    contacts={contacts}
                    candidates={candidates}
                    form={form}
                    submitting={editing}
                  />
                ) : (
                  <center><Spin spinning indicator={<Icon type="loading" />} />&nbsp;&nbsp;Loading...</center>
                )
              }
            </Modal>
          ) : null
        }

        <div>
          <Row>
            <Col span={8}>
              {renderCard('#B284BE', invoices.totalGBP, 'Total Great British Pounds', '£')}
            </Col>

            <Col span={8}>
              {renderCard('#72A0C1', invoices.totalSGD.toFixed(2), 'Total Singapore Dollar', 'S$', `/ £${invoices.totalSGDtoGBP.toLocaleString()}`)}
            </Col>

            <Col span={8}>
              {renderCard('#DE5D83', invoices.totalHKD.toFixed(2), 'Total Hong Kong Dollar', 'HK$', `/ £${invoices.totalHKDtoGBP.toLocaleString()}`)}
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={8}>
              {renderCard('#B0BF1A', invoices.totalInvoices, 'Total Invoices', null, `/ £${(invoices.totalGBP + invoices.totalSGDtoGBP + invoices.totalHKDtoGBP).toLocaleString()}`)}
            </Col>
          </Row>
        </div>

        <br />

        <Tabs
          type="card"
          tabBarExtraContent={
            <div>
              Currency Rate: &nbsp;&nbsp;
              <Tag color="#72A0C1"><b>SGD: {sgdRate.toFixed(3)}</b></Tag>
              <Tag color="#72A0C1"><b>HKD: {hkdRate.toFixed(3)}</b></Tag>
              <i style={{ color: '#ddd', fontSize: '12px' }}>updated {format(new Date(moment(currencyUpdate).format('YYYY-MM-DD HH:mm:ss')))}</i>
            </div>
          }
        >
          <TabPane tab={<div><FontAwesomeIcon icon={faChartBar} />&nbsp;&nbsp;Charts</div>} key="1">
            {
              invoices.onGoingInvoices.length === 0 && invoices.paidInvoices.length === 0 && invoices.withdrawInvoices.length === 0 ? (
                <div>
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
              ) : (
                <Row>
                  <Col span={7}>
                    <ResponsiveContainer width={'100%'} height={250}>
                      <ComposedChart
                        data={data2.reverse()}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" tick={<CustomizedAxisTick />} />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend content={() => (<center>Number of invoices from last 6 months</center>)} />
                        <Area type="monotone" dataKey="invoices" fill="#B0BF1A" stroke="#72A0C1" />
                        <Area type="monotone" dataKey="withdraw" fill="#DE5D83" stroke="#FF8C00" />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </Col>

                  <Col span={8}>
                    <ResponsiveContainer width={'100%'} height={250}>
                      <ComposedChart
                        data={data3.reverse()}
                        margin={{
                          top: 5, right: 15, bottom: 5, left: 15,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" tick={<CustomizedAxisTick />} />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="gbp" barSize={20} fill="#DE5D83" />
                        <Bar dataKey="sgd" barSize={20} fill="#7CB9E8" />
                        <Bar dataKey="hkd" barSize={20} fill="#FF8C00" />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </Col>

                  <Col span={9}>
                    <ResponsiveContainer width={'100%'} height={325}>
                      <PieChart>
                        <Pie
                          activeIndex={activeIndex}
                          activeShape={renderActiveShape}
                          data={data1}
                          cy={125}
                          innerRadius={81}
                          outerRadius={108}
                          fill="#8884d8"
                          dataKey="value"
                          onMouseEnter={onPieEnter}
                        >
                          {
                            data1.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
                          }
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  </Col>
                </Row>
              )
            }
          </TabPane>
        </Tabs>

        <Tabs
          onChange={(value) => {
            setActiveTab(value);
          }}
          type="card" tabBarExtraContent={
            <>
              {
                activeTab === '1' ? (
                  <>
                    <Button
                      size="small"
                      type="primary"
                      onClick={() => {
                        setShowRateModal(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faChartLine} />&nbsp;Currency Rate History
                    </Button>
                    &nbsp;&nbsp;
                    <Button size="small" type="primary" onClick={() => {
                      setShowCreateInvoiceModal(true);
                    }}><Icon type="plus-square" /> New Invoice</Button>
                  </>
                ) : null
              }
              {
                activeTab === '4' ? (
                  <div>
                    <Select
                      value={activeYear}
                      style={{ width: '400px' }}
                      onChange={async (value) => {
                        setActiveYear(value);
                        setReportLoading(true);
                        const reportResponse = await getReport(session.authToken, yearsArr[value].start, yearsArr[value].end, yearsArr[value].type);
                        setReportData({
                          period: reportResponse.data.period,
                          data: reportResponse.data.data,
                          chartData: reportResponse.data.chartData,
                        });
                        setReportLoading(false);
                      }}
                    >
                      {
                        yearsArr.map((i, k) => {
                          return (
                            <Option key={k} value={k}>{i.name} ({i.start} to {i.end})</Option>
                          )
                        })
                      }
                    </Select>
                  </div>
                ) : null
              }
            </>
          }>
          <TabPane tab={<div><FontAwesomeIcon icon={faCalendarAlt} />&nbsp;&nbsp;On Going</div>} key="1">
            <Spin spinning={updating} indicator={<Icon type="loading" />}>
              {
                invoices ? (
                  <>
                    <Alert message={buildAlertMessage(invoices)} type="info" showIcon />
                    <br />
                  </>
                ) : null
              }
              <Table
                columns={columnsWithStatus}
                dataSource={invoices.onGoingInvoices}
                rowKey="id"
              />
            </Spin>
          </TabPane>
          <TabPane tab={<div><FontAwesomeIcon icon={faPiggyBank} />&nbsp;&nbsp;Payment Received</div>} key="2">
            <Row>
              <Col span={12}>
                {paymentReceivedPanel === 'current year' && renderCurrentYearTotal()}
              </Col>
              <Col span={12}>
                <div style={flexCenterRight}>
                  <Radio.Group
                    buttonStyle="solid"
                    defaultValue="current year"
                    onChange={(e) => {
                      setPaymentReceivedPanel(e.target.value);
                    }}
                  >
                    <Radio.Button value="current year"><FontAwesomeIcon icon={faCalendarAlt} /> Current Year</Radio.Button>
                    <Radio.Button value="all time"><FontAwesomeIcon icon={faCalendarAlt} /> All Time</Radio.Button>
                  </Radio.Group>
                </div>
              </Col>
            </Row>
            <br />
            {renderPaymentReceivedPanel()}
          </TabPane>
          <TabPane tab={<div><FontAwesomeIcon icon={faExclamationCircle} />&nbsp;&nbsp;Withdraw</div>} key="3">
            <Row>
              <Col span={12} />
              <Col span={12}>
                <div style={flexCenterRight}>
                  <Radio.Group
                    buttonStyle="solid"
                    defaultValue="current year"
                    onChange={(e) => {
                      setWithdrawPanel(e.target.value);
                    }}
                  >
                    <Radio.Button value="current year"><FontAwesomeIcon icon={faCalendarAlt} /> Current Year</Radio.Button>
                    <Radio.Button value="all time"><FontAwesomeIcon icon={faCalendarAlt} /> All Time</Radio.Button>
                  </Radio.Group>
                </div>
              </Col>
            </Row>
            <br />
            {renderWithdrawPanel()}
          </TabPane>
          <TabPane tab={<div><FontAwesomeIcon icon={faList} />&nbsp;&nbsp;Transactions</div>} key="5">
            <TransactionPanel transactionsData={transactions} users={users} />
          </TabPane>
          <TabPane tab={<div><FontAwesomeIcon icon={faFilePdf} />&nbsp;&nbsp;Reports</div>} key="4">
            <ReportPanel reportData={reportData} loading={reportLoading} />
          </TabPane>
        </Tabs>
      </Form>
  )
}

const Invoices = Form.create({ name: 'invoices' })(TheInvoices);
export default Invoices;
